import { OrderDto, RestaurantTypeValues, StatutCommandes } from '@timechef/core/api';
import { ensureDate } from '@timechef/core/utils';
import { isAfter, isSameDay, startOfWeek, subDays, subWeeks } from 'date-fns';
import { ItemsByPeriod, Order, PeriodEnum } from './history.models';

// Do not store this grouping because it changes every day, instead we compute it on the fly when required
export const computeHistory = <T extends { date: string }>(today: Date, dtos: T[], existing?: ItemsByPeriod<T>[]): ItemsByPeriod<T>[] => {
  const byPeriod: ItemsByPeriod<T>[] = existing || [
    { period: PeriodEnum.Coming, items: [] },
    { period: PeriodEnum.Today, items: [] },
    { period: PeriodEnum.Yesterday, items: [] },
    { period: PeriodEnum.ThisWeek, items: [] },
    { period: PeriodEnum.LastWeek, items: [] },
    { period: PeriodEnum.Previously, items: [] },
  ];

  const addToPeriod = (period: PeriodEnum, item: T) => byPeriod.find((x) => x.period === period)!.items.push(item);

  const yesterday = subDays(today, 1);
  // weekStartsOn : 1 = monday
  const startOfTodayWeek = startOfWeek(today, { weekStartsOn: 1 });
  const startOfLastWeek = subWeeks(startOfTodayWeek, 1);

  dtos.forEach((ticket) => {
    const date = ensureDate(ticket.date);
    if (isSameDay(date, today)) addToPeriod(PeriodEnum.Today, ticket);
    else if (isAfter(date, today)) addToPeriod(PeriodEnum.Coming, ticket);
    else if (isSameDay(date, yesterday)) addToPeriod(PeriodEnum.Yesterday, ticket);
    else if (isAfter(date, startOfTodayWeek)) addToPeriod(PeriodEnum.ThisWeek, ticket);
    else if (isAfter(date, startOfLastWeek)) addToPeriod(PeriodEnum.LastWeek, ticket);
    else addToPeriod(PeriodEnum.Previously, ticket);
  });

  return byPeriod;
};

export const mapOrderDtoToOrder = (dto: OrderDto): Order => {
  const isCc = dto.restaurant.type === RestaurantTypeValues.ClickAndCollect;
  const order: Order = {
    ...dto,
    isCollected: dto.status === StatutCommandes.DtaPayeeRetiree,
    isCc,
  };

  return order;
};

export const isTableValid = (table: number, order: Order) => {
  return table > 0 && (!order.restaurant.maxTableNumber || table <= order.restaurant.maxTableNumber);
};
